import { useLocation, useNavigate } from 'react-router';

import { useCurrentUserContext } from 'contexts/currentUser';
import { WalletTab, useWalletDrawerContext } from 'contexts/walletDrawer';
import { useQueryString } from 'hooks/useQueryString';

export const usePromptAddFunds = () => {
  const { currentUser } = useCurrentUserContext();

  const { showDrawer, mounted, setCurrentTab, currentTab } =
    useWalletDrawerContext();
  const action = useQueryString('action');
  const location = useLocation();
  const navigate = useNavigate();

  if (
    action !== 'addFunds' ||
    !mounted ||
    !currentUser ||
    currentTab === WalletTab.ADD_FUNDS
  ) {
    return;
  }
  setCurrentTab(WalletTab.HOME);
  showDrawer();

  navigate(location.pathname, { replace: true });
};
